import React from "react";
import Typography from "@material-ui/core/Typography";
import * as APIStore from "../../store/APIStore";
import Paper from '@material-ui/core/Paper';

export interface NextSiteOfCareProps {
    nextSiteOfCare: APIStore.NextSiteOfCare
}

const NextSiteOfCare = (props: NextSiteOfCareProps) => {
    let { nextSiteOfCare } = props;
    if (!nextSiteOfCare) {
        return (<></>)
    }
    return (
        <div>
            <Typography variant="h2" component="div" gutterBottom>
                <strong>Next Site Of Care:</strong>
            </Typography>
            {
                nextSiteOfCare.name
            }
        </div>
    )
}
export default NextSiteOfCare;
